import { TanStackDevtools } from '@tanstack/react-devtools';
import { formDevtoolsPlugin } from '@tanstack/react-form-devtools';
import { ReactQueryDevtoolsPanel } from '@tanstack/react-query-devtools';
import { HeadContent, Outlet, useLocation } from '@tanstack/react-router';
import { TanStackRouterDevtoolsPanel } from '@tanstack/react-router-devtools';
import { Suspense } from 'react';

import { VestigasDevtools } from '~/modules/devtools';
import { RoutingProgressIndicator } from '~/modules/router';

import { Spinner } from '@vestigas/ui/molecules';

/**
 * Layout for public routes that don't require authentication.
 * Provides general-purpose infrastructure (routing progress, suspense, devtools)
 * without any initialization logic.
 */
export function PublicRouteRootLayout() {
  const location = useLocation();

  return (
    <>
      <RoutingProgressIndicator key={location.pathname} />
      <HeadContent />
      <Suspense fallback={<Spinner />}>
        <Outlet />
      </Suspense>
      <TanStackDevtools
        config={{
          defaultOpen: false,
          panelLocation: 'bottom',
          port: 8090,
          position: 'bottom-left',
        }}
        plugins={[
          {
            name: 'TanStack Query',
            render: <ReactQueryDevtoolsPanel />,
          },
          {
            name: 'TanStack Router',
            render: <TanStackRouterDevtoolsPanel />,
          },
          {
            name: 'Vestigas Devtools',
            render: <VestigasDevtools />,
          },
          formDevtoolsPlugin(),
        ]}
      />
    </>
  );
}
